// extracted by mini-css-extract-plugin
export default {"formGroup":"Switch_formGroup__LPYeG","inLine":"Switch_inLine__IoKtY","input":"Switch_input__GrRqL","disabled":"Switch_disabled__6INoS","green":"Switch_green__8QS7q"};